import { ComponentProps, ReactElement } from "react";
import styles from "./styles.module.scss";
import ChevronIcon from "@/common/svg/chevron-icon.svg";
import { Typography } from "shared/ui/Typography";

interface Props extends ComponentProps<"button"> {
  text: ReactElement;
  Icon?: ReactElement;
}

export const ChevronButton = ({ text, Icon, ...props }: Props) => {
  return (
    <button {...props} className={styles.chevronButton}>
      <div className={styles.main}>
        {!!Icon && Icon}
        <Typography type="bodyBold" className={styles.text}>
          {text}
        </Typography>
      </div>
      <div className={styles.chevronWrapper}>
        <ChevronIcon />
      </div>
    </button>
  );
};
